class Component {
	constructor(props = {}) {
		this.props = props;
		this.children = [];
		this.className = '';
		this.refs = {};
		this.component;
		this.key;
	}

	// passing props from parent to multiple children
	getPassedProps(passedProps) {
		this.props = {
			...this.props,
			...passedProps,
		};
	}

	getClassName() {
		return this.className;
	}

	getComponent() {
		return this.component ? this.component : null;
	}

	// implement in subclasses
	// necessary DOM manipulation, setup children event listeners and elements
	componentDidMount() {}
	// call after markup content updated
	componentDidUpdate() {}

	componentWillUnmount() {}
    
	render() {}

	createRefs() {
		this.component.querySelectorAll('[ref]').forEach((elem) => {
			this.refs[elem.getAttribute('ref')] = elem;
		});
	}

	setRefs(refs) {
		this.refs = refs;
	}

	setKey(key) {
		this.key = key;
		return this;
	}

	getKey() {
		return this.key;
	}

	// mount component into DOM tree
	mount(container) {
		container.insertAdjacentHTML('afterbegin', this.render());
		this.component = container.querySelector(`[ref="component-${this.key}"]`);
		this.createRefs();
		this.componentDidMount();
	}

	unmount() {
		this.componentWillUnmount();
		this.component.remove();
	}

	setChildren(componentsArray) {
		componentsArray.forEach((componentObj) => {
			const component = new componentObj['component'](componentObj.props);
			component.setKey(componentObj.props.id ?? '');
			this.children.push(component);

			if (componentObj.props.children) {
				component.setChildren(componentObj.props.children);
			}
		});

		// to chain other methods
		return this;
	}

	// dispatch events, to control other components
	dispatchCustomEvent(eventName, target = this.component, bubbles = true, options = {}) {
		const event = new CustomEvent(eventName, {
			bubbles: bubbles,
			detail: {
				...options
			}
		});

		target.dispatchEvent(event);
	}

	// dispatch built-in event
	dispatchEvent(eventName, target, bubbles = true) {
		const event = new Event(eventName, {bubbles: bubbles});
		target.dispatchEvent(event);
	}
}

export default Component;